import { Component, h, Host, Prop } from '@stencil/core';
import { Size, PillType, BorderType } from './types';

export interface AhaPill extends HTMLAhaPillElement {}

/**
 * A simple pill that can be used in many different use cases.
 *
 * @slot Default - Contents the `aha-pill` element.
 */
@Component({
  tag: 'aha-pill',
  styleUrl: 'aha-pill.css',
  shadow: true,
})
export class AhaPill {
  /**
   * The background color of the pill. Can be any CSS color string.
   */
  @Prop() color?: string;

  /**
   * DEPRECATED: Whether the status is editable (show arrows icon). Use
   * aha-select-pill instead.
   */
  @Prop() editable: boolean = false;

  /** The size of the pill. */
  @Prop({ reflect: true }) size: Size = 'medium';

  /**
   * The color of the pills border. Can be any CSS color string.
   */
  @Prop() borderColor?: string;

  /**
   * The color of the pills text. Can be any CSS color string.
   */
  @Prop() textColor?: string;

  /**
   * The shape of the border, either square or round.
   */
  @Prop() borderShape?: BorderType = 'square';

  /**
   * Changes the pill to just have a border and the text is the same color
   * as the border
   */
  @Prop() type: PillType = 'solid';

  /**
   * remove the top and bottom padding on the inside span
   */
  @Prop() short: boolean = false;

  /**
   * The opacity of the border color. This is only used when the border color is set
   */
  @Prop() borderOpacity: number = 1;

  render() {
    const styles: { [key: string]: string } = {};

    if (this.color) {
      if (this.type === 'outline') {
        styles['--aha-pill--fg-color'] = this.color;
        styles['--aha-pill--border-color'] = this.color;
      } else {
        styles['--aha-pill--bg-color'] = this.color;
      }
    }

    if (this.textColor) {
      styles['--aha-pill--fg-color'] = this.textColor;
    }

    if (this.borderColor) {
      if (this.borderColor.includes('-rgb-')) {
        styles['border'] = `1px solid rgba(${this.borderColor}, ${this.borderOpacity})`;
      } else {
        styles['border'] = `1px solid var(--aha-pill--border-color, ${this.borderColor})`;
      }
    }

    if (this.short) {
      styles['padding-top'] = `0`;
      styles['padding-bottom'] = `0`;
    }

    return (
      <Host>
        <span style={styles} part="content">
          <slot></slot>
          {this.editable && <aha-icon icon="aha-icon aha-icon-sort"></aha-icon>}
        </span>
      </Host>
    );
  }
}
